import { useRef, useEffect } from 'react'

export const useScrollInput = (callback: () => void) => {
  const savedCallback = useRef<() => void>()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const callback = () => {
      if (savedCallback.current) {
        savedCallback.current()
      }
    }
    document.addEventListener('wheel', callback, true)

    return () => {
      document.removeEventListener('wheel', callback, true)
    }
  }, [])
}
